import React, { useEffect, useState } from "react";
import "./charts.css";

// segments: [{ label, value, color }]
// Animated SVG donut. Stroke draws in on mount via stroke-dashoffset transition.
export default function Donut({ segments = [], size = 168, stroke = 18, centerTop, centerBottom }) {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    const t = requestAnimationFrame(() => setShown(true));
    return () => cancelAnimationFrame(t);
  }, []);

  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const total = segments.reduce((s, x) => s + (x.value || 0), 0);

  let offsetAcc = 0;
  const arcs = segments.map((seg, i) => {
    const frac = total > 0 ? seg.value / total : 0;
    const len = frac * circ;
    const dasharray = `${len} ${circ - len}`;
    const dashoffset = shown ? -offsetAcc : -circ; // start collapsed, grow to position
    offsetAcc += len;
    return (
      <circle
        key={i}
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke={seg.color}
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeDasharray={dasharray}
        strokeDashoffset={dashoffset}
        className="donut-arc"
        style={{ transitionDelay: `${i * 90}ms` }}
      />
    );
  });

  return (
    <div className="donut-wrap" style={{ width: size, height: size }}>
      <svg width={size} height={size} style={{ transform: "rotate(-90deg)" }}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.05)"
          strokeWidth={stroke}
        />
        {total > 0 && arcs}
      </svg>
      <div className="donut-center">
        {centerTop && <div className="donut-center-top">{centerTop}</div>}
        {centerBottom && <div className="donut-center-bottom">{centerBottom}</div>}
      </div>
    </div>
  );
}
